export default __webpack_public_path__ + "static/media/6@2x.d14bf60a.png";